import { render } from "./Footer.vue?vue&type=template&id=ab4d5b92&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=ab4d5b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4d5b92"]])

export default __exports__